<template lang="pug">
  div
    .video-block
      a.video-pop-up(@click="open_video()")
        img(:src="`https://img.youtube.com/vi/${youtube_id}/hqdefault.jpg`")
    #youtube.modal.modal-blur.fade.show(tabindex='-1' role='dialog' style='display: none;' aria-hidden='true' )
      .modal-dialog.modal-dialog-centered.modal-lg(role='document')
        .modal-content
          .modal-body
            iframe(type='text/html' width='670' height='400' :src="`//www.youtube.com/embed/${youtube_id}`" frameborder='0')

</template>

<script>

export default {
  name: 'Youtube',
  props: ['url'],
  computed:{
    youtube_id(){
      var url = this.url??'';
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
      // return video_id;
    },
  },
  methods:{
    open_video(){
      $('#youtube').modal('show');
    }
  }
}
</script>

<style lang="scss" scoped>
.video-block{
  display: inline-block;
  background: white;
  padding: 10px 10px 10px 10px;
  box-shadow: 1px 1px 3px #666;

  iframe{
    max-width: 100%;
  }

  img{
    max-width:100%;
  }
}

</style>